import * as React from 'react';

export function App({ children }: React.PropsWithChildren<{}>) {
    return <div>{children}</div>;
}
